import styled from 'styled-components';

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;

  .page-item {
    width: 5vw;
    height: 5vw;
    max-width: 40px;
    max-height: 40px;
    min-width: 32px;
    min-height: 32px;
    margin: 0 0.5% 0;
    display: flex;
    align-items: center;
    justify-content: center;
    background: rgba(98, 92, 92, 0.2);
    cursor: pointer;
    border-radius: 50%;

    &.hide {
      display: none;
    }

    &.minifyed {
      margin: 0 10px 0;
      min-width: 10px;
      min-height: 10px;
      width: 10px !important;
      height: 10px !important;
      background: #e0dede !important;
      color: transparent !important;

      &.active {
        background: #18A0FB !important;
        color: transparent !important;
      }

      a {
        color: transparent !important;
      }
    }

    a {
      font-family: 'Lato', sans-serif;
      width: 100%;
      height: 100%;
      display: flex;
      align-items: center;
      justify-content: center;
      border-radius: 50%;
      color: #364863;
    }

    &.active {
      background: #18A0FB !important;
      a {
        color: #fff;
      }
    }
  }

  @media (max-width: 768px) {
    .page-item {
      width: 12vw;
      height: 12vw;
      min-width: 50px;
      min-height: 50px;
      margin: 0 1%;
    }
  }
`;
